import ActionTypes from "../constants/action_types";
import DocumentActionTypes from "modules/documents/constants/action_types";
import {MaybeUninitialised} from "modules/redux_types";
import {AddAmendmentClauseChangesAction} from "../actions/amendments_add_clause_change";
import {ClearAmendmentClauseChangesAction} from "../actions/amendments_clear";
import {AmendmentClauseChangeErrorAction} from "../actions/amendments_clause_change_error";
import {
  ClauseChangeError,
  ProcessedClauseChange,
} from "common/flowmaster/types/amendment";
import {Uuid} from "common/types";

type Action =
  | AddAmendmentClauseChangesAction
  | ClearAmendmentClauseChangesAction
  | AmendmentClauseChangeErrorAction;

interface AmendmentsState {
  clauseChanges: MaybeUninitialised<ProcessedClauseChange[]>;
  completedIds: Uuid[];
  errors: ClauseChangeError[];
}

const initialState: AmendmentsState = {
  clauseChanges: [],
  completedIds: [],
  errors: [],
};

export default function amendmentsReducer(
  state: AmendmentsState = initialState,
  action: Action,
) {
  switch (action.type) {
    case ActionTypes.AMENDMENT_CLAUSE_CHANGES_ADD.SUCCESS:
      return {
        ...state,
        clauseChanges: action.payload,
      };
    case ActionTypes.AMENDMENT_CLAUSE_CHANGE_ERROR.SUCCESS: {
      const errorIndex = state.errors.findIndex(
        error => error.clauseChangeId === action.payload.clauseChangeId,
      );
      if (errorIndex === -1) {
        return {
          ...state,
          errors: [...state.errors, action.payload],
        };
      } else {
        return {
          ...state,
          errors: state.errors.map((error, index) =>
            index === errorIndex
              ? {...error, message: action.payload.message}
              : error,
          ),
        };
      }
    }
    case DocumentActionTypes.DOCUMENT_ISSUE_RESET_APPLIED_AMENDMENTS.SUCCESS:
      return initialState;
    case ActionTypes.AMENDMENT_CLAUSE_CHANGES_CLEAR.SUCCESS:
      return initialState;
    default:
      return state;
  }
}
